
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class TaxTypesDialog extends Serenity.EntityDialog<TaxTypesRow, any> {
        protected getFormKey() { return TaxTypesForm.formKey; }
        protected getIdProperty() { return TaxTypesRow.idProperty; }
        protected getLocalTextPrefix() { return TaxTypesRow.localTextPrefix; }
        protected getNameProperty() { return TaxTypesRow.nameProperty; }
        protected getService() { return TaxTypesService.baseUrl; }
        protected getDeletePermission() { return TaxTypesRow.deletePermission; }
        protected getInsertPermission() { return TaxTypesRow.insertPermission; }
        protected getUpdatePermission() { return TaxTypesRow.updatePermission; }

        protected form = new TaxTypesForm(this.idPrefix);

    }
}